import { toast } from "react-toastify";

export const showToast = (message, toastId, toastShownRef) => {
  if (!toastShownRef.current) {
    toast.error(message, {
      toastId,
      onClose: () => (toastShownRef.current = false),
    });
    toastShownRef.current = true;
  }
};
